"use client";

import { type RefObject, useLayoutEffect, useRef, useState } from "react";

/** Share the host scroll pane; only a new board resets the learner's view. */
export function useStreamingScroll(
  container: RefObject<HTMLDivElement | null>,
  boardIdentity: object
) {
  const owner = useRef<HTMLElement | null>(null);
  const [hostPane, setHostPane] = useState<HTMLElement | null>(null);
  useLayoutEffect(() => {
    const node = container.current;
    if (!node) return;
    const pane = node.closest<HTMLElement>("[data-whiteboard-scroll]") ?? node;
    owner.current = pane;
    setHostPane(pane !== node ? pane : null);
    return () => {
      owner.current = null;
    };
  }, [container]);
  useLayoutEffect(() => {
    owner.current?.scrollTo?.({ top: 0, behavior: "auto" });
  }, [boardIdentity]);
  return { hostScroll: Boolean(hostPane) };
}
